import { loanDetailsData } from "configs/loanDetails.config";
import { Dropdown, FilePicker, Input, Textarea } from "stories";
import {
	completedProjectFields,
	currentProjectFields
} from "./corporationFields";

export const solePartnershipFields = [
  [
    {
      name: "corporate_structure",
      component: Dropdown,
      props: {
        label: "Corporate Structure",
        list: loanDetailsData.corporationTypeList,
      },
    },
    {
      name: "fullname",
      component: Input,
      props: {
        label: "Full Name",
      },
    },
    {
      name: "identification",
      component: Input,
      props: {
        label: "Identification",
      },
    },
  ],
  [
    {
      name: "biography",
      component: Textarea,
      props: {
        label: "Biography",
      },
    },
  ],
  [
    {
      name: "address",
      component: Input,
      props: {
        label: "Address",
      },
    },
    {},
  ],
  [
    {
      name: "personal_net_worth",
      component: Input,
      props: {
        label: "Personal Net-Worth",
        type: "currency",
        startAdornment: "$",
      },
    },
    {},
  ],
  [
    {
      name: "net_worth_document_filename",
      component: FilePicker,
      props: {
        label: "Net Worth Documentation",
        type: "file",
      },
    },
    {},
  ],
  [completedProjectFields],
  [currentProjectFields],
];
